import { useQuery } from "@vue/apollo-composable";
import type { ComputedRef } from "vue";
import { TenancyFilterBookmarksDocument } from "~/graphql/generated/graphql";

export const useDefaultTenancyFilterBookmarkQuery = () => {
  const query = useQuery(TenancyFilterBookmarksDocument);

  const result = computed(() => query.result.value?.assetManagementTenancyFilterBookmarks.find((fm) => fm.isDefault));

  const loading = computed(() => query.loading.value);

  const promise = computed(() => (query.loading.value ? new Promise((res) => query.onResult((result) => res(result.data))) : null));

  return {
    result,
    loading,
    promise,
  };
};
